import React, { useState } from 'react';
import axios from 'axios';

const inputStyle = {
  width: '100%', padding: '10px 14px', borderRadius: 8,
  background: 'var(--bg-card)', border: '1px solid var(--border)', color: 'var(--text1)',
  fontSize: 14, outline: 'none', boxSizing: 'border-box',
};

export default function LoginPage({ onLogin }) {
  const [step, setStep]         = useState('credentials'); // 'credentials' | 'totp'
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const payload = { username, password };
      if (step === 'totp') payload.totp_code = totpCode;
      const res = await axios.post('/api/auth/login', payload);
      onLogin(res.data);
    } catch (err) {
      const detail = err.response?.data?.detail || 'Login fehlgeschlagen';
      if (detail === 'TOTP_REQUIRED') {
        setStep('totp');
        setError('');
      } else {
        setError(detail);
      }
    } finally {
      setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg-app)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{
        width: 380, background: 'var(--bg-surface)', border: '1px solid var(--border)',
        borderRadius: 16, padding: '40px 32px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>⚡</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#22c55e', letterSpacing: '.06em' }}>ENERGY BPOS</div>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 4 }}>Trade Finance Suite</div>
        </div>

        {error && (
          <div style={{ padding: '10px 14px', background: '#ef444415', border: '1px solid #ef444440',
            borderRadius: 8, color: '#ef4444', fontSize: 13, marginBottom: 16 }}>{error}</div>
        )}

        <form onSubmit={submit}>
          {step === 'credentials' && (
            <>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text2)', marginBottom: 6 }}>
                  Benutzername
                </label>
                <input type="text" value={username} onChange={e => setUsername(e.target.value)}
                  required autoFocus style={inputStyle} />
              </div>
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text2)', marginBottom: 6 }}>
                  Passwort
                </label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                  required style={inputStyle} />
              </div>
            </>
          )}

          {step === 'totp' && (
            <div style={{ marginBottom: 24 }}>
              <div style={{ textAlign: 'center', marginBottom: 20 }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🔐</div>
                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text1)', marginBottom: 4 }}>
                  Zwei-Faktor-Authentifizierung
                </div>
                <div style={{ fontSize: 12, color: 'var(--text3)' }}>
                  Gib den 6-stelligen Code aus deiner Authenticator-App ein.
                </div>
              </div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text2)', marginBottom: 6 }}>
                Authenticator-Code
              </label>
              <input
                type="text" value={totpCode} onChange={e => setTotpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                required autoFocus placeholder="123456" maxLength={6}
                style={{ ...inputStyle, textAlign: 'center', fontSize: 24, letterSpacing: '.3em', fontWeight: 700 }}
              />
              <button type="button" onClick={() => { setStep('credentials'); setTotpCode(''); setError(''); }}
                style={{ background: 'none', border: 'none', color: 'var(--text3)', fontSize: 12, cursor: 'pointer',
                  marginTop: 10, textDecoration: 'underline' }}>
                ← Zurück zur Anmeldung
              </button>
            </div>
          )}

          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '11px', borderRadius: 8, border: 'none',
              background: '#22c55e', color: '#000', fontWeight: 700, fontSize: 14,
              cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? .7 : 1 }}>
            {loading ? 'Prüfe…' : step === 'totp' ? 'Bestätigen' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
